// Mock data for Rooftopper website

export const companyInfo = {
  name: "ROOFTOPPER",
  phone: "416-688-9988",
  email: "info@top-canada.ca",
  address: "30 West Beaver Creek Rd Unit 113, Richmond Hill, ON",
  yearsInBusiness: 20,
  foundedYear: 2011
};

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      projects: "Projects",
      testimonials: "Testimonials",
      contact: "Contact"
    },
    hero: {
      title: "Top-Quality Roofing Contractor in GTA",
      subtitle: "Based in Richmond Hill, ON, we have been providing high-quality roof installation, repair and maintenance services at affordable prices since 2011",
      cta: "Get Free Quote",
      ctaSecondary: "Call Now"
    },
    promo: {
      title: "SAVE UP TO $500",
      subtitle: "On Complete Roof Replacement",
      description: "Need a roof replacement? Contact us today to save up to $500 on your project."
    },
    about: {
      title: "Your Trusted Roofing Contractor",
      subtitle: "Over 20 Years of Excellence",
      description: "When you're in need of roof repair, replacement or installation of a new roof, it's important to choose the right people to do the job. Your roof is what protects your family, your furniture and all your belongings.",
      description2: "Trust us and we'll get your job done quickly, effectively and affordably.",
      features: [
        { title: "20% New Customer Discount", desc: "For repair services" },
        { title: "Flexible Financing", desc: "Pay over time options" },
        { title: "Free Roof Inspection", desc: "For new installations" }
      ]
    },
    services: {
      title: "Our Services",
      subtitle: "Professional Roofing Solutions",
      items: [
        {
          title: "Residential Roofing",
          description: "Professional roof installation, repair and maintenance for homes using premium materials."
        },
        {
          title: "Siding Services",
          description: "High-quality siding installation with licensed and insured protection for your home."
        },
        {
          title: "Commercial Roofing",
          description: "Expert roofing services for commercial projects of all sizes and complexities."
        },
        {
          title: "Emergency Repairs",
          description: "Fast response emergency roof repair services available when you need them most."
        }
      ]
    },
    projects: {
      title: "Our Recent Work",
      subtitle: "Quality Results You Can Trust",
      viewMore: "View All Projects"
    },
    testimonials: {
      title: "What Our Clients Say",
      subtitle: "Trusted by Homeowners Across GTA"
    },
    contact: {
      title: "Get In Touch",
      subtitle: "Request a Free Quote Today",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Email Address",
        address: "Property Address",
        service: "Service Needed",
        message: "Tell us about your project",
        submit: "Request Quote"
      },
      info: {
        address: "Our Address",
        phone: "Call Us",
        email: "Email Us"
      }
    },
    serviceAreas: {
      title: "Service Areas",
      subtitle: "Proudly Serving the Greater Toronto Area",
      areas: ["Richmond Hill", "Markham", "Toronto", "Vaughan", "Newmarket", "Aurora", "Thornhill", "Scarborough"]
    },
    footer: {
      description: "Your trusted roofing contractor in GTA area. Quality workmanship, premium materials, and customer satisfaction guaranteed.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact Info",
      rights: "All rights reserved."
    }
  },
  zh: {
    nav: {
      home: "首页",
      about: "关于我们",
      services: "服务项目",
      projects: "工程案例",
      testimonials: "客户评价",
      contact: "联系我们"
    },
    hero: {
      title: "大多伦多地区顶级屋顶承包商",
      subtitle: "位于列治文山，自2011年以来，我们以实惠的价格提供高质量的屋顶安装、维修和保养服务",
      cta: "免费报价",
      ctaSecondary: "立即致电"
    },
    promo: {
      title: "节省高达$500",
      subtitle: "完整屋顶更换",
      description: "需要更换屋顶？立即联系我们，您的项目最多可节省$500。"
    },
    about: {
      title: "您值得信赖的屋顶承包商",
      subtitle: "超过20年的卓越服务",
      description: "当您需要屋顶维修、更换或安装新屋顶时，选择合适的人来完成工作非常重要。您的屋顶保护着您的家人、家具和所有物品。",
      description2: "信任我们，我们将快速、有效且经济实惠地完成您的工作。",
      features: [
        { title: "新客户8折优惠", desc: "维修服务" },
        { title: "灵活分期付款", desc: "可分期支付" },
        { title: "免费屋顶检查", desc: "新安装项目" }
      ]
    },
    services: {
      title: "服务项目",
      subtitle: "专业屋顶解决方案",
      items: [
        {
          title: "住宅屋顶",
          description: "使用优质材料为房屋提供专业的屋顶安装、维修和保养服务。"
        },
        {
          title: "外墙壁板",
          description: "高质量壁板安装，持牌并投保，保护您的房屋。"
        },
        {
          title: "商业屋顶",
          description: "为各种规模和复杂程度的商业项目提供专业屋顶服务。"
        },
        {
          title: "紧急维修",
          description: "在您最需要的时候提供快速响应的紧急屋顶维修服务。"
        }
      ]
    },
    projects: {
      title: "近期工程",
      subtitle: "值得信赖的优质成果",
      viewMore: "查看全部项目"
    },
    testimonials: {
      title: "客户评价",
      subtitle: "深受大多伦多地区房主信赖"
    },
    contact: {
      title: "联系我们",
      subtitle: "立即获取免费报价",
      form: {
        name: "姓名",
        phone: "电话号码",
        email: "电子邮件",
        address: "房产地址",
        service: "所需服务",
        message: "描述您的项目",
        submit: "获取报价"
      },
      info: {
        address: "公司地址",
        phone: "联系电话",
        email: "电子邮件"
      }
    },
    serviceAreas: {
      title: "服务区域",
      subtitle: "服务大多伦多地区",
      areas: ["列治文山", "万锦", "多伦多", "旺市", "新市", "奥罗拉", "康山", "士嘉堡"]
    },
    footer: {
      description: "大多伦多地区值得信赖的屋顶承包商。优质工艺、优质材料、客户满意保证。",
      quickLinks: "快速链接",
      services: "服务项目",
      contact: "联系方式",
      rights: "版权所有。"
    }
  }
};

export const projects = [
  {
    id: 1,
    title: { en: "New Roof Installation", zh: "新屋顶安装" },
    location: { en: "Markham", zh: "万锦" },
    date: "2024",
    before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600",
    after: "https://images.unsplash.com/photo-1635424824800-692767998d07?w=600",
    category: "residential"
  },
  {
    id: 2,
    title: { en: "Complete Roof Replacement", zh: "完整屋顶更换" },
    location: { en: "Richmond Hill", zh: "列治文山" },
    date: "2024",
    before: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600",
    after: "https://images.unsplash.com/photo-1633759593085-1eaeb724fc88?w=600",
    category: "residential"
  },
  {
    id: 3,
    title: { en: "Commercial Roofing Project", zh: "商业屋顶项目" },
    location: { en: "Toronto", zh: "多伦多" },
    date: "2023",
    before: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600",
    after: "https://images.unsplash.com/photo-1635424709870-cdc6e64f0e20?w=600",
    category: "commercial"
  },
  {
    id: 4,
    title: { en: "Storm Damage Repair", zh: "风暴损坏维修" },
    location: { en: "Vaughan", zh: "旺市" },
    date: "2024",
    before: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=600",
    after: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?w=600",
    category: "repair"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Susan M.",
    location: { en: "Richmond Hill", zh: "列治文山" },
    rating: 5,
    text: {
      en: "Our roof was broken after a storm and they came in just ONE hour to help! The contractor was professional, friendly and polite and they got the roof repaired quickly. Thank you!",
      zh: "暴风雨后我们的屋顶损坏了，他们一小时内就来帮忙了！承包商专业、友好、有礼貌，很快就修好了屋顶。谢谢！"
    }
  },
  {
    id: 2,
    name: "Andrew J.",
    location: { en: "Markham", zh: "万锦" },
    rating: 5,
    text: {
      en: "Excellent work on our complete roof replacement. The team was efficient, clean, and the new roof looks amazing. Highly recommend their services!",
      zh: "完整屋顶更换工作做得非常好。团队高效、整洁，新屋顶看起来很棒。强烈推荐他们的服务！"
    }
  },
  {
    id: 3,
    name: "David L.",
    location: { en: "Toronto", zh: "多伦多" },
    rating: 5,
    text: {
      en: "Very professional service from start to finish. Fair pricing, quality materials, and excellent craftsmanship. Will definitely use them again.",
      zh: "从头到尾都非常专业的服务。价格公道、材料优质、工艺精湛。一定会再次使用他们的服务。"
    }
  },
  {
    id: 4,
    name: "Jennifer W.",
    location: { en: "Vaughan", zh: "旺市" },
    rating: 5,
    text: {
      en: "The team did an outstanding job on our siding installation. They were punctual, respectful of our property, and the results exceeded our expectations.",
      zh: "团队在我们的壁板安装上做得非常出色。他们准时、尊重我们的财产，结果超出了我们的预期。"
    }
  }
];

export const serviceOptions = [
  { value: "residential", label: { en: "Residential Roofing", zh: "住宅屋顶" } },
  { value: "commercial", label: { en: "Commercial Roofing", zh: "商业屋顶" } },
  { value: "siding", label: { en: "Siding Services", zh: "壁板服务" } },
  { value: "repair", label: { en: "Roof Repair", zh: "屋顶维修" } },
  { value: "inspection", label: { en: "Roof Inspection", zh: "屋顶检查" } },
  { value: "emergency", label: { en: "Emergency Service", zh: "紧急服务" } }
];
